import type React from "react";

import { Avatar } from "@/components/avatar";
import { Badge } from "@/components/badge";
import { Dialog, DialogBody, DialogCloseButton } from "@/components/dialog";
import { Modal } from "@/components/modal";
import { OriginalInputFields } from "@/features/request/edit/components/design-brief-section/OriginalInputFields";
import { useGetRequest } from "@/hooks/useGetRequest.tsx";
import { dateFormatter } from "@/utils/dateFormatter.ts";

interface SubmitWarningModalProps {
  isOpen: boolean;
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
}

export function OriginalInputModal({
  isOpen,
  onOpenChange,
}: SubmitWarningModalProps) {
  const { data: request } = useGetRequest();

  return (
    <Modal
      classNames={{ modal: "w-full" }}
      isDismissable
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog>
        <DialogBody className="pb-3xl">
          <div className="flex flex-col gap-xs">
            <span className="text-lg font-semibold text-text-primary">
              Magical Brief Creator Form
            </span>
            <DialogCloseButton />
          </div>
          <div className="flex items-center">
            <span className="whitespace-nowrap mr-1">Original input by </span>
            <Badge size="large">
              <Badge.Icon>
                <Avatar
                  alt="Jhon Doe"
                  className="mr-1 size-4"
                  src={request?.creator.profilePicture}
                />
              </Badge.Icon>
              {request?.creator.name}
            </Badge>
            <span className="whitespace-nowrap ml-1">
              {dateFormatter(request?.createdAt)}
            </span>
          </div>
          <OriginalInputFields />
        </DialogBody>
      </Dialog>
    </Modal>
  );
}
